import { render, staticRenderFns } from "./distributionWrapper.vue?vue&type=template&id=0e1f055f&scoped=true"
import script from "./distributionWrapper.vue?vue&type=script&lang=js"
export * from "./distributionWrapper.vue?vue&type=script&lang=js"
import style0 from "./distributionWrapper.vue?vue&type=style&index=0&id=0e1f055f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f055f",
  null
  
)

export default component.exports